module.exports = __webpack_public_path__ + "img/passo_3.67988d2d.png";